import {
  followRecords,
  addFollowRecord,
  updateFollowRecord,
  uploadFollowRecordMaterials,
  deleteFollowRecord,
  deleteFollowRecordMaterials,
  downloadFollowRecordMaterial
} from '@/http/api/companyStore.js';
import {
  getCompanyStoreSettings
} from '@/http/api/system.js';
import videoPlay from '@/components/VideoPlay/index.vue';
import pdf from 'vue-pdf';
export default {
  components: {
    videoPlay,
    pdf
  },
  data() {
    return {
      loading: true,
      pdfSrc: '',
      isPdfShow: false,
      recordFileList: [],
      uploadTimer: null, //定时器,上传附件时节流防抖
      editGrowthId: '', //编辑的巡店记录的id
      editGrowthIndex: '', //编辑的巡店记录的index
      uploading: false,
      employeInfo: '', //用户信息
      dialogType: "add", //弹窗类型
      inputValue: "all",
      today: new Date().Format("yyyy-MM-dd"),
      time: '',
      pageIndex: 1,
      noMore: false,
      query: {
        companyStoreId: this.$route.params.id,
        skipCount: 0,
        maxResultCount: 10,
        followType: '',
        startTime: '',
        endTime: '',
        timeCondition: 'EffectiveTime',
        sorting: 'EffectiveTime desc'
      },
      options: [{
          value: "all",
          label: "全部时间"
        },
        {
          value: "userDefined",
          label: "自定义时间"
        }
      ],
      //巡店记录
      followType: [],
      fileList: [],
      videoList: [],
      uploadLoading: "", //上传加载中对象
      material: [],
      moveDataelse: {
        x: null,
        y: null
      },
      addFilePosition: {
        //保存移动前的位置，判断是否移动
        x: null,
        y: null
      },
      videoUrl: "", //视频播放地址
      isShowAdd: false, //控制添加弹窗
      addQuery: {
        //添加数据参数
        type: "",
        desc: "",
        time: "",
        imgList: [],
        videoList: [],
        textList: []
      },
      addRules: {
        type: [{
          required: true,
          message: "请选择记录类型",
          trigger: "change"
        }],
        desc: [{
          required: true,
          message: "请输入记录描述",
          trigger: "change"
        }],
        time: [{
          required: true,
          message: "请选择记录时间",
          trigger: "change"
        }]
      },
      permissions: this.$store.getters.permissions,
    };
  },
  methods: {
    //处理图片预览数组
    previewImgList: function (imgList) {
      if (imgList) {
        return imgList.map((item) => {
          return item.url;
        });
      }
    },
    //选择时间类型
    employeTime(val) {
      if (val === "all") {
        this.time = this.query.startTime = this.query.endTime = '';
        this.getGrowthList(true);
      }
    },
    //选择时间范围
    chooseTime(val) {
      this.query.startTime = val[0];
      this.query.endTime = val[1];
      this.getGrowthList(true);
    },
    //巡店记录基础字段
    getCompanySettings() {
      getCompanyStoreSettings().then((res) => {
        //console.log('巡店记录基础字段:', res);
        for (let i = 0; i < res.result.length; i++) {
          if (res.result[i].name == "Deer.CompanyStore.Collection.FollowType") {
            this.followType = res.result[i].value;
            break;
          }
        }
      })
    },
    //整理获取的巡店记录格式
    settleGrowthData(item) {
      //整理时间
      var arr = item.effectiveTime.split(' ')[0].split('-');
      item.year = arr[0];
      item.day = arr[1] + '月' + arr[2] + '日';
      //整理类型
      item.imgList = [];
      item.videoList = [];
      item.textList = [];
      item.materials.forEach(items => {
        // 图片类型
        var FileExt = items.fileName.replace(/.+\./, "");
        if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
          item.imgList.push(items); //将bade64位图片保存至数组里供上面图片显示
        }
        // 视频类型
        if (["mp4"].indexOf(FileExt.toLowerCase()) > -1) {
          item.videoList.push(items); //将bade64位图片保存至数组里供上面图片显示
        }
        // 文件类型
        if (
          ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
          -1
        ) {
          item.textList.push(items);
        }
      });
    },
    //预览文件
    previewFile(url) {
      if (!/\.(pdf|PDF)$/.test(url)) {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + url);
      } else {
        this.pdfSrc = url;
        this.isPdfShow = true;
      }
    },
    closeDialog(done) {
      done();
    },
    // 获取巡店记录
    getGrowthList(isFirstPage) {
      //console.log(isFirstPage);
      //console.log(this.query);
      if (isFirstPage) {
        this.query.skipCount = 0;
        this.pageIndex = 1;
      } else {
        this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
      }
      followRecords(this.query).then((res) => {
        //console.log('巡店记录：', res);
        this.loading = false;
        if (res.code == 10200) {
          this.pageIndex++;
          if (res.result.items.length < this.query.maxResultCount) {
            this.noMore = true;
          }
          res.result.items.forEach(item => {
            this.settleGrowthData(item);
          });
          if (isFirstPage) {
            this.material = res.result.items;
          } else {
            this.material = this.material.concat(res.result.items);
          }
        }
      })
    },
    // 添加分销商门店巡店记录
    addGrowthRecord() {
      this.addQuery.time = this.addQuery.time.substr(0, 11) + '00' + this.addQuery.time.substr(13, this.addQuery.time.length - 1);
      var query = new FormData();
      this.fileList.forEach(item => {
        query.append('Files', item.raw);
      });
      query.append('followType', this.addQuery.type);
      query.append('Description', this.addQuery.desc);
      if (this.addQuery.time) {
        query.append('EffectiveTime', this.addQuery.time);
      }
      this.uploading = true;
      addFollowRecord(this.$route.params.id, query).then((res) => {
        //console.log('添加巡店记录：', res);
        if (res.code == 10200) {
          this.uploading = false;
          this.$message.success({
            message: "添加巡店记录成功",
            showClose: true
          });
          this.isShowAdd = false;
          this.clearAddQuery();
          this.getGrowthList(true);
        }
      });
    },
    // 更新分销商门店巡店记录
    updateGrowthRecord() {
      this.addQuery.time = this.addQuery.time.substr(0, 11) + '00' + this.addQuery.time.substr(13, this.addQuery.time.length - 1);
      var query = {
        "followType": this.addQuery.type,
        "description": this.addQuery.desc,
        "effectiveTime": this.addQuery.time
      }
      this.uploading = true;
      updateFollowRecord(this.editGrowthId, query).then((res) => {
        //console.log('更新分销商门店巡店记录:', res);
        if (res.code == 10200) {
          this.uploading = false;
          this.$set(this.material[this.editGrowthIndex], 'description', res.result.description);
          this.$set(this.material[this.editGrowthIndex], 'followType', res.result.followType);
          this.$set(this.material[this.editGrowthIndex], 'effectiveTime', res.result.effectiveTime);
          //整理时间
          var arr = res.result.effectiveTime.split(' ')[0].split('-');
          this.$set(this.material[this.editGrowthIndex], 'year', arr[0]);
          this.$set(this.material[this.editGrowthIndex], 'day', arr[1] + '月' + arr[2] + '日');
          this.isShowAdd = false;
          this.clearAddQuery();
        }
      });
    },
    // 删除分销商门店巡店记录
    deleteGrowthRecord(id, index) {
      if (!this.permissions['Company.Stores.ManageFollowRecords']) {
        this.$message.warning({
          message: `您暂无分销商门店巡店记录管理权限`,
          showClose: true,
        });
        return;
      }
      this.$confirm('此操作将永久删除该条巡店记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var query = {
          RecordIds: id
        };
        deleteFollowRecord(this.$route.params.id, query).then(res => {
          //console.log('删除巡店记录:', res);
          if (res.code == 10200) {
            this.$message.success({
              message: "删除巡店记录成功",
              showClose: true
            });
            this.material.splice(index, 1);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          showClose: true
        });
      });
    },
    //删除巡店记录附件  档案id，文件id，档案下标，对应类型字段名，对应字段下标
    deleteMaterialFile(rid, mid, rIndex, name, mIndex) {
      if (!this.permissions['Company.Stores.ManageFollowRecords']) {
        this.$message.warning({
          message: `您暂无分销商门店巡店记录管理权限`,
          showClose: true,
        });
        return;
      }
      this.$confirm('此操作将永久删除该条巡店记录附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 请求
        deleteFollowRecordMaterials(rid, {
          MaterialIds: mid
        }).then(res => {
          //console.log('删除巡店记录附件:', res);
          if (res.code == 10200) {
            this.$message.success({
              message: "删除巡店记录附件成功",
              showClose: true
            });
            this.material[rIndex][name].splice(mIndex, 1);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          showClose: true
        });
      });
    },
    // 下载员工成长资料附件
    downloadGrowthRecordMaterial(fileName) {
      if (!this.permissions['Company.Stores.DownloadFollowRecordMaterials']) {
        this.$message.warning({
          message: `您暂无分销商门店巡店记录资料下载权限`,
          showClose: true,
        });
        return;
      }
      downloadFollowRecordMaterial(this.$route.params.id, {
        fileName
      }).then((res) => {
        const content = res;
        //console.log(res);
        const blob = new Blob([content]);
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      });
    },
    // 上传分销商门店巡店记录资料附件
    uploadGrowthRecordMaterials(e) {
      if (e.file.size / 1024 / 1024 > 5) {
        this.$message.success({
          message: "文件大于5M",
          showClose: true
        });
        return;
      }
      if (!this.permissions['Company.Stores.UploadFollowRecordMaterials']) {
        this.$message.warning({
          message: `您暂无分销商门店巡店记录资料上传权限`,
          showClose: true,
        });
        return;
      }
      this.recordFileList.push(e.file);
      clearTimeout(this.uploadTimer);
      this.uploadTimer = setTimeout(() => {
        var query = new FormData();
        this.recordFileList.forEach((item) => {
          query.append('files', item);
        });
        this.loading = true;
        uploadFollowRecordMaterials(e.data.id, query).then((res) => {
          this.loading = false;
          //console.log(res);
          if (res.code == 10200) {
            this.$message.success({
              message: "添加附件资料成功",
              showClose: true
            });
            this.settleGrowthData(res.result);
            this.material.splice(e.data.index, 1, res.result);
          }
        });
      }, 100);
    },
    //清空参数
    clearAddQuery() {
      this.fileList = []; //文件列表
      this.addQuery = {
        //添加数据参数
        type: "",
        time: "",
        desc: "",
        imgList: [],
        videoList: [],
        textList: []
      };
    },
    //管理
    edit(item, index) {
      if (!this.permissions['Company.Stores.ManageFollowRecords']) {
        this.$message.warning({
          message: `您暂无分销商门店巡店记录管理权限`,
          showClose: true,
        });
        return;
      }
      this.editGrowthId = item.id; //编辑的id
      this.editGrowthIndex = index; //编辑的下标
      this.dialogType = "edit";
      this.isShowAdd = true;
      this.clearAddQuery();
      //处理数据
      this.addQuery.type = item.followType;
      this.addQuery.time = item.effectiveTime;
      this.addQuery.desc = item.description;
      // item.materials.forEach(item => {
      //   // 图片类型
      //   var FileExt = item.fileName.replace(/.+\./, "");
      //   if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
      //     item.name = this.employeInfo.name;
      //     this.addQuery.imgList.push(item); //将bade64位图片保存至数组里供上面图片显示
      //   }
      //   // 视频类型
      //   if (["mp4"].indexOf(FileExt.toLowerCase()) > -1) {
      //     item.name = this.employeInfo.name;
      //     this.addQuery.videoList.push(item); //将bade64位图片保存至数组里供上面图片显示
      //   }
      //   // 文件类型
      //   if (
      //     ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
      //     -1
      //   ) {
      //     this.addQuery.textList.push(item);
      //   }
      // });
    },
    //删除文件
    delFile(key, index, uid) {
      this.addQuery[key].splice(index, 1);
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].uid == uid) {
          this.fileList.splice(i, 1);
          //console.log(this.fileList);
          return;
        }
      }
    },
    //添加文件、上传成功和上传失败时都会被调用
    uploadChange(file, fileList) {
      if (file.size / 1024 / 1024 > 5) {
        this.$message.success({
          message: "文件大于5M",
          showClose: true
        });
        return;
      }
      this.fileList = fileList;
      // 图片类型
      var FileExt = file.name.replace(/.+\./, "");
      if (["jpg", "png", "jpeg"].indexOf(FileExt.toLowerCase()) > -1) {
        var reader = new FileReader();
        reader.onload = () => {
          file.url = reader.result;
          file.name = this.employeInfo.name;
          file.creationTime = this.today;
          this.addQuery.imgList.push(file); //将bade64位图片保存至数组里供上面图片显示
        };
        reader.readAsDataURL(file.raw);
      }
      // 视频类型
      if (["mp4"].indexOf(FileExt.toLowerCase()) > -1) {
        var reader = new FileReader();
        reader.onload = () => {
          file.url = reader.result;
          file.name = this.employeInfo.name;
          file.creationTime = this.today;
          this.addQuery.videoList.push(file); //将bade64位图片保存至数组里供上面图片显示
        };
        reader.readAsDataURL(file.raw);
      }
      // 文件类型
      if (
        ["txt", "pdf", "doc", "docx", "xlsx"].indexOf(FileExt.toLowerCase()) >
        -1
      ) {
        this.addQuery.textList.push(file);
      }
    },
    //确认提交
    creatSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogType == 'add') { //添加
            this.addGrowthRecord();
          } else if (this.dialogType == 'edit') { //修改
            this.updateGrowthRecord();
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    //关闭视频弹窗
    closeVideo() {
      this.videoUrl = "";
    },
    //添加档案弹窗
    showAddMaterial() {
      if (!this.permissions['Company.Stores.ManageFollowRecords']) {
        this.$message.warning({
          message: `您暂无分销商门店巡店记录管理权限`,
          showClose: true,
        });
        return;
      }
      this.clearAddQuery();
      this.isShowAdd = true;
      this.dialogType = 'add';
    },
    mouseDownHandleelse(event) {
      // event.currentTarget.style.cursor = 'move';
      this.addFilePosition = {
        x: this.$refs.addFile.offsetLeft,
        y: this.$refs.addFile.offsetTop
      };
      this.moveDataelse.x = event.pageX - this.$refs.addFile.offsetLeft;
      this.moveDataelse.y = event.pageY - this.$refs.addFile.offsetTop;
      window.onmousemove = this.mouseMoveHandleelse;
    },
    mouseMoveHandleelse(event) {
      let moveLeft = event.pageX - this.moveDataelse.x + "px";
      let moveTop = event.pageY - this.moveDataelse.y + "px";
      this.$refs.addFile.style.left = moveLeft;
      this.$refs.addFile.style.top = moveTop;
    },
    mouseUpHandleelse(event) {
      window.onmousemove = null;
      // event.currentTarget.style.cursor = ' pointer';
      //没有移动
      if (
        this.addFilePosition.x == this.$refs.addFile.offsetLeft &&
        this.addFilePosition.y == this.$refs.addFile.offsetTop
      ) {
        this.showAddMaterial();
      }
    },
  },
  created() {
    this.getCompanySettings();
    this.getGrowthList(true);
  }
};